import { create } from 'zustand';
// TODO: Presence feature is temporarily disabled due to potential bugs
// import { presenceService, SessionData } from '../services/crdt/presenceService';

// Mock SessionData type to maintain interface compatibility
interface SessionData {
  id: string;
  user: any;
  cursor?: { x: number; y: number };
  [key: string]: any;
}

interface PresenceState {
  sessions: Record<string, SessionData>;
  isConnected: boolean;
  currentUser: any;
}

interface PresenceActions {
  connect: (spaceId: string, user: any) => () => void;
  updateCursor: (x: number, y: number) => void;
  disconnect: () => void;
}

type PresenceStore = PresenceState & PresenceActions;

export const usePresenceStore = create<PresenceStore>((set, get) => ({
  // State
  sessions: {},
  isConnected: false,
  currentUser: null,

  // Actions - Mock implementations
  connect: (spaceId: string, user: any) => {
    // Mock: Just set the user and connected state without actual connection
    set({ currentUser: user, isConnected: true });

    // Return a mock disconnect function
    return () => {
      set({ isConnected: false, sessions: {} });
    };
  },

  updateCursor: (x: number, y: number) => {
    // Mock: Do nothing, just maintain interface compatibility
    const { currentUser, isConnected } = get();
    if (!isConnected || !currentUser) return;
    
    // TODO: Actual cursor update would happen here
    // presenceService.updateCursor(x, y, currentUser);
  },

  disconnect: () => {
    // Mock: Just reset state without actual disconnection
    set({ isConnected: false, sessions: {}, currentUser: null });
  },
}));

export type { SessionData };

// Mock presenceService export to maintain compatibility
export const presenceService = {
  connect: (spaceId: string, callback: (sessions: Record<string, SessionData>) => void) => {
    // Mock: Return a no-op disconnect function
    return () => {};
  },
  updateCursor: (x: number, y: number, user: any) => {
    // Mock: Do nothing
  },
  disconnect: () => {
    // Mock: Do nothing
  },
};

/* COMMENTED OUT - ORIGINAL IMPLEMENTATION
export const usePresenceStore = create<PresenceStore>((set, get) => ({
  // State
  sessions: {},
  isConnected: false,
  currentUser: null,

  // Actions
  connect: (spaceId: string, user: any) => {
    set({ currentUser: user, isConnected: true });

    const disconnect = presenceService.connect(spaceId, (sessions) => {
      set({ sessions });
    });

    return () => {
      disconnect();
      set({ isConnected: false, sessions: {} });
    };
  },

  updateCursor: (x: number, y: number) => {
    const { currentUser, isConnected } = get();
    if (!isConnected || !currentUser) return;
    
    presenceService.updateCursor(x, y, currentUser);
  },

  disconnect: () => {
    presenceService.disconnect();
    set({ isConnected: false, sessions: {}, currentUser: null });
  },
}));

export type { SessionData };
export { presenceService }; 
*/ 